import React, { useEffect, useCallback, useState} from 'react';
import {setParameterMinMax} from 'actions/index.js';
import {isNumber} from 'utils/IsNumber.js';
import {connect} from 'react-redux';

const PMinMaxEditor = ({value, parameter, arg, label, setParameterMinMax}) => { 
    let [editing, setEditing] = useState(false);
    let [editValue, setEditValue] = useState(value);

    useEffect(() => {
        setEditValue(value);
    }, [value, setEditValue]);

    const onChange = useCallback((e) => {
        let value = e.target.value;
        if (value === '.') {
            value = 0;
        } else if (value === '-') {
            value = 0;
        } else if (value === '') {
            value = 0;
        } else if (!isNumber(value)) {
            return;
        }
        value = parseFloat(value);
        parameter[arg] = value;
        let bulk = {};
        bulk[parameter.id] = {
            min: parameter.min,
            max: parameter.max,
        };
        bulk[parameter.id][arg] = value;
        setParameterMinMax(bulk);
        setEditValue(value);
    }, [setEditValue, arg, parameter]);

    useEffect(() => {
        if (!editing) {
            setEditValue(value);
        }
    }, [editing, value, setEditValue]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter") {
            setEditing(false);
        }
    }, [setEditing]);

    let className = "d-parameter-" + arg;
    if (editing) {
        return (
            <div className={className}>{label}:
              <input onKeyDown={onKeyDown} className="min-max-input" value={editValue} onChange={onChange} type="text"/></div>);
    }
    return (<div
              onClick={() => setEditing(true)}
              className={className}>{label}: {Math.round(value*1000)/1000}</div>);
}

const mapStateToProps = (state, props) => {
  return {
      value: props.parameter[props.arg],
      _value: props.parameter.get(true),
      depth: props.parameter._depth,
      minMax: state.effects.parameterMinMax[props.parameter.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setParameterMinMax: (b) => dispatch(setParameterMinMax(b))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PMinMaxEditor);
